<template>
  <div>
    <div
      v-if="isDeal"
      class="deal_at flex flex-vertical-center"
    >
      <div class="deal_at--text">
        <p class="deal_at--label">Deal At</p>
        <p class="deal_at--date">@ {{ formatDate(record.record.deal_at) }}</p>
      </div>
      <button-icon
        icon="edit"
        color="is-secondary"
        @click="$refs.leadDealForm.open(record.record)"
      ></button-icon>
    </div>
    <form-field-switch
      v-else
      label="DEAL?"
      v-model="isDeal"
      is-left-label
      is-deal-switch
    ></form-field-switch>

    <!-- Lead Deal Form -->
    <modal-container>
      <modal-crud-form
        ref="leadDealForm"
        title="Deal At"
        form-component="lead-deal-form"
        hide-delete-button
      >
        <template v-slot:buttons>
          <div class="mr-auto">
            <button-link
              color="is-danger"
              :loading="isDealLoading"
              @click="markedNotADeal"
            >
              Not A Deal
            </button-link>
          </div>
        </template>
      </modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import dates from "../../../services/dates";

export default {
  name: "RecordDeal",
  data() {
    return {
      isDealLoading: false,
    }
  },
  computed: {
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord : {
        record: {
          deal_at: null,
        }
      };
    },
    isDeal: {
      get() { return !!(this.record.record.deal_at) },
      set(val) { this.setDealAt(val) }
    },
  },
  methods: {
    formatDate(isoString) {
      return dates.formatAsDate(isoString);
    },
    setDealAt(isDeal) {
      if (! isDeal) return;

      const data = { deal_at: new Date().toISOString() };
      this.$api.records.markAsDeal(this.record.record.id, data)
        .then(() => {
          this.$buefy.toast.open({
            message: 'Lead was marked as Deal',
            type: 'is-success'
          });
        });
    },
    markedNotADeal() {
      this.$utils.confirm(
        `Are you sure you want to mark this lead as <strong>not a deal</strong>?`,
        'Mark As Not A Deal'
      )
        .then(() => {
          this.isDealLoading = true;
          this.$api.records.unmarkAsDeal(this.record.record.id)
            .then(() => {
              this.$refs.leadDealForm.close();
              this.$buefy.toast.open({
                message: 'Lead was marked as Not A Deal',
                type: 'is-success'
              });
            })
            .finally(() => this.isDealLoading = false);
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.deal_at {

  &--text {
    display: flex;
    align-items: center;
  }

  &--label {
    margin-right: 6px;
    color: $primary;
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
  }

  &--date {
    font-size: 14px;
    color: $text-muted;
  }
}
</style>
